import { API_MYEDUZZ } from 'settings';

export const API_MAP = {
  // AUTHENTICATION
  login: `${API_MYEDUZZ}/auth`,
  loginAs: `${API_MYEDUZZ}/auth/as`,
  // GENERAL
  user: `${API_MYEDUZZ}/auth/details`,
  profile: `${API_MYEDUZZ}/profile`,
  markOrbitaAbandonment: `${API_MYEDUZZ}/customers/orbita_abandonment`,
  customers: `${API_MYEDUZZ}/customers`,
  customer: `${API_MYEDUZZ}/customers/{id}`,
  customerSurvey: `${API_MYEDUZZ}/customers/{id}/answer`,
  customerBadge: `${API_MYEDUZZ}/customers/{customerId}/badge`,
  customerEditEmail: `${API_MYEDUZZ}/customers/{id}/editEmail`,
  loadCustomerByEmail: `${API_MYEDUZZ}/customers?email={email}`,
  isNewbie: `${API_MYEDUZZ}/profile/show_quick_start`,
  saveTourAction: `${API_MYEDUZZ}/profile/tour`,
  checkPassword: `${API_MYEDUZZ}/profile/checkPassword`,
  checkIfUserhaveCoproductionGains: `${API_MYEDUZZ}/customers/has_coproduction_gains`,
  // REPORTS
  listMyLeads: `${API_MYEDUZZ}/reports/leads`,
  listProductsFiltersLeads: `${API_MYEDUZZ}/reports/leads/products`,
  listCampaignsFiltersLeads: `${API_MYEDUZZ}/reports/leads/campaigns`,
  listAffiliatesFiltersLeads: `${API_MYEDUZZ}/reports/leads/affiliates`,
  listTypesFiltersLeads: `${API_MYEDUZZ}/reports/leads/types`,
  listSale: `${API_MYEDUZZ}/reports/sales`,
  saleSimpleExport: `${API_MYEDUZZ}/reports/sales/export`,
  saleDetailedExport: `${API_MYEDUZZ}/reports/sales/export/detailed`,
  listSaleById: `${API_MYEDUZZ}/reports/sales?invoice_id={id}`,
  listInvoiceStatus: `${API_MYEDUZZ}/reports/paymentstatus`,
  backgroundReport: `${API_MYEDUZZ}/reports/background/export/sales`,
  backgroundReportSales: `${API_MYEDUZZ}/reports/export/sales`,
  exportLeadsListToCsv: `${API_MYEDUZZ}/reports/leads/export`,
  exportLaunch: `${API_MYEDUZZ}/reports/saleslaunch`,
  infoMoneyTransferFile: `${API_MYEDUZZ}/transfers/{id}/composition`,
  // INVOICES
  loadInvoiceById: `${API_MYEDUZZ}/invoices/{id}`,
  listInvoiceItems: `${API_MYEDUZZ}/invoices/{id}/items`,
  checkCanRefund: `${API_MYEDUZZ}/invoices/{id}/refund-verify`,
  loadInvoiceHistory: `${API_MYEDUZZ}/invoices/{id}/history?grouping=true`,
  refundInvoice: `${API_MYEDUZZ}/invoices/{id}/refund`,
  addAffiliateInvoice: `${API_MYEDUZZ}/invoices/{invoice_id}/affiliate`,
  listProductAccess: `${API_MYEDUZZ}/invoices/{invoice_id}/links`,
  listAccessHistory: `${API_MYEDUZZ}/invoices/{invoice_id}/accesses`,
  invoiceDelivery: `${API_MYEDUZZ}/invoices/{invoice_id}/delivery`,
  setNewDueDate: `${API_MYEDUZZ}/subscriptions/{contract}/duedate/{invoiceId}`,
  listPinsByInvoiceId: `${API_MYEDUZZ}/invoices/{invoice_id}/pins`,
  partialRefundInvoice: `${API_MYEDUZZ}/invoices/{invoice_id}/partialrefund`,
  downloadRefundReceipt: `${API_MYEDUZZ}/invoices/{invoice_id}/refund-receipt`,
  // PRODUCT
  productHasDelivery: `${API_MYEDUZZ}/products/{id}/has_delivery`,
  loadProductById: `${API_MYEDUZZ}/products/{id}`,
  cloneProductById: `${API_MYEDUZZ}/products/{id}/clone`,
  listMyProducts: `${API_MYEDUZZ}/products`,
  listProductsChildren: `${API_MYEDUZZ}/products?parent_id={id}&per_page=1000`,
  listMyProductsSales: `${API_MYEDUZZ}/reports/products`,
  newProduct: `${API_MYEDUZZ}/products`,
  editProduct: `${API_MYEDUZZ}/products/{id}`,
  listCategories: `${API_MYEDUZZ}/categories`,
  listDeliveryMethodByProduct: `${API_MYEDUZZ}/products/{id}/deliverymethods`,
  listCoProducerByProduct: `${API_MYEDUZZ}/products/{id}/coproducers`,
  listMyVariations: `${API_MYEDUZZ}/reports/products/{id}/variations`,
  listMyAffiliates: `${API_MYEDUZZ}/reports/affiliates`,
  listMyCoupons: `${API_MYEDUZZ}/reports/coupons`,
  listDeliveryProviders: `${API_MYEDUZZ}/deliveryproviders`,
  uploadDeliveryProviders: `${API_MYEDUZZ}/products/{id}/deliverymethods`,
  createBatch: `${API_MYEDUZZ}/products/{id}/deliverymethods/createbatch`,
  listProductBadges: `${API_MYEDUZZ}/products/{id}/badges`,
  listProductInvoice: `${API_MYEDUZZ}/products/{id}/invoices`,
  productStatus: `${API_MYEDUZZ}/products/{id}/changestatus`,
  productInviteAffiliate: `${API_MYEDUZZ}/products/{id}/affiliate`,
  productDelivery: `${API_MYEDUZZ}/products/{id}/delivery`,
  listCurrency: `${API_MYEDUZZ}/currencies`,
  loadFileById: `${API_MYEDUZZ}/files/{id}`,
  addNewCoproducer: `${API_MYEDUZZ}/products/{id}/coproducers`,
  trackers: `${API_MYEDUZZ}/pixel?product_id={product_id}`,
  verifyDomain: `${API_MYEDUZZ}/pixel/verify`,
  createTrackers: `${API_MYEDUZZ}/pixel`,
  createPosback: `${API_MYEDUZZ}/trackers`,
  listPostback: `${API_MYEDUZZ}/trackers`,
  listCoupons: `${API_MYEDUZZ}/products/{id}/coupons`,
  listCouponsBatch: `${API_MYEDUZZ}/products/{id}/batchcoupons`,
  exportCouponsBatch: `${API_MYEDUZZ}/products/{id}/batchcoupons/{hash}/export`,
  inactivateCouponsBatch: `${API_MYEDUZZ}/products/{id}/batchcoupons/{hash}`,
  excludeCoupon: `${API_MYEDUZZ}/products/{product_id}/coupons/{id}/exclude`,
  createCoupon: `${API_MYEDUZZ}/products/{product_id}/coupons`,
  createBatchCoupon: `${API_MYEDUZZ}/products/{product_id}/batchcoupons`,
  listAffiliations: `${API_MYEDUZZ}/affiliations`,
  listCoProductions: `${API_MYEDUZZ}/coproductions`,
  // RECOVERY MESSAGES
  listRecoveryMessages: `${API_MYEDUZZ}/products/{id}/recoveryemails`,
  updateRecoveryMessages: `${API_MYEDUZZ}/products/{product_id}/recoveryemails/{id}`,
  // FINANCIAL
  loadMyExtract: `${API_MYEDUZZ}/extracts`,
  loadMyBlockedExtract: `${API_MYEDUZZ}/extracts/blocked`,
  loadMyFutureExtract: `${API_MYEDUZZ}/extracts?credited_at=future`,
  availableTransfer: `${API_MYEDUZZ}/transfers/available`,
  bankTransfer: `${API_MYEDUZZ}/transfers`,
  anticipationTransfer: `${API_MYEDUZZ}/anticipation`,
  loadExtractItems: `${API_MYEDUZZ}/extracts/items?date={date}`,
  listInvoicesAnticipation: `${API_MYEDUZZ}/anticipation`,
  listTransfers: `${API_MYEDUZZ}/transfers`,
  loadFilterByMonth: `${API_MYEDUZZ}/extracts?period=month`,
  // NUTROR
  listNutrorCourses: `${API_MYEDUZZ}/deliveryproviders/nutror`,
  // UPLOAD FILES
  upload: `${API_MYEDUZZ}/files`,
  // PROFILE ACCOUNTS
  listBanks: `${API_MYEDUZZ}/fundtransfers/banks`,
  resendConfirmation: `${API_MYEDUZZ}/fundtransfers/{uuid}/resend-confirmation`,
  createAccount: `${API_MYEDUZZ}/fundtransfers`,
  listAccounts: `${API_MYEDUZZ}/fundtransfers`,
  getMyProfile: `${API_MYEDUZZ}/profile`,
  saveMyProfile: `${API_MYEDUZZ}/profile`,
  // RECOVER PASSWORD
  recover: `${API_MYEDUZZ}/auth/recover`,
  changePassword: `${API_MYEDUZZ}/auth/changepassword`,
  // DASHBOARD
  dashValues: `${API_MYEDUZZ}/dashboard`,
  lastSales: `${API_MYEDUZZ}/dashboard/lastsales`,
  lastLeads: `${API_MYEDUZZ}/dashboard/leads`,
  dashProducts: `${API_MYEDUZZ}/dashboard/products`,
  listNewzz: `${API_MYEDUZZ}/news`,
  clickNewzz: `${API_MYEDUZZ}/news/{id}/click`,
  indications: `${API_MYEDUZZ}/dashboard/indications`,
  bestsellers: `${API_MYEDUZZ}/dashboard/bestsellers`,
  lastgains: `${API_MYEDUZZ}/dashboard/lastgains`,
  periodsalesgains: `${API_MYEDUZZ}/dashboard/periodsalesgains`,
  // COPRODUCER
  moderateCoproducers: `${API_MYEDUZZ}/acceptance/coproducer`,
  // CAMPAIGNS
  listProductCampaigns: `${API_MYEDUZZ}/products/{id}/campaigns`,
  // Download Content (delivery)
  downloadFile: `${API_MYEDUZZ}/downloadfile`,
  validateDownloadHash: `${API_MYEDUZZ}/validatedownloadhash`,
  // BOLETOS
  sendBoleto: `${API_MYEDUZZ}/invoices/{invoice_id}/resend`,
  // ACCESS POLICIES
  accessPolicyModule: `${API_MYEDUZZ}/access-control/modules`,
  accessPolicyAccesses: `${API_MYEDUZZ}/access-control/accesses`,
  accessPolicySwitchAccount: `${API_MYEDUZZ}/access-control/switchaccount`,
  accessPolicyPermissions: `${API_MYEDUZZ}/access-control/permissions`,
  accessPolicyGroupList: `${API_MYEDUZZ}/access-control/groups`,
  accessPolicyGroupCreate: `${API_MYEDUZZ}/access-control/groups`,
  accessPolicyGroupUpdate: `${API_MYEDUZZ}/access-control/groups/{id}`,
  accessPolicyGroupDelete: `${API_MYEDUZZ}/access-control/groups/{id}`,
  accessPolicyUserList: `${API_MYEDUZZ}/access-control/users`,
  accessPolicyUserCreate: `${API_MYEDUZZ}/access-control/users`,
  accessPolicyUserUpdate: `${API_MYEDUZZ}/access-control/users/{id}`,
  accessPolicyUserDelete: `${API_MYEDUZZ}/access-control/users/{id}`,
  // CDF
  cdfList: `${API_MYEDUZZ}/fiscaldocuments`,
  cdfDetailsItems: `${API_MYEDUZZ}/fiscaldocuments/{id}/items`,
  cdfDetailsFiles: `${API_MYEDUZZ}/fiscaldocuments/{id}/downloads`,
  cdfUrlDownload: `${API_MYEDUZZ}/fiscaldocuments/{id}/export`,
  exportCDF: `${API_MYEDUZZ}/fiscaldocuments/export`,
  // CLICK AND CONVERSIONS
  conversionSearch: `${API_MYEDUZZ}/conversion`,
  conversionGraphics: `${API_MYEDUZZ}/conversion/graphics`,
  conversionUtmsGraphics: `${API_MYEDUZZ}/conversion/utms`,
  conversionTopPaymentMethod: `${API_MYEDUZZ}/conversion/paymentmethod`,
  conversionTopAffiliates: `${API_MYEDUZZ}/conversion/affiliates`,
  conversionGraphicsSales: `${API_MYEDUZZ}/conversion/graphics/sales`,
  conversionListUtms: `${API_MYEDUZZ}/conversion/filters/utms`,
  conversionListCampaigns: `${API_MYEDUZZ}/conversion/filters/campaigns`,
  //AFFILIATES
  listAffiliates: `${API_MYEDUZZ}/affiliates`,
  getPendingAffiliatesSummary: `${API_MYEDUZZ}/affiliates/pending-summary`,
  configCustomCommission: `${API_MYEDUZZ}/affiliates/{id}/commission`,
  moderateAffiliate: `${API_MYEDUZZ}/affiliates/{id}/moderate`,
  moderateMultipleAffiliates: `${API_MYEDUZZ}/affiliates/moderate`,
  getAffiliatesProductStatusSummary: `${API_MYEDUZZ}/affiliates/statussummary/product/{id}`,
  // SUBSCRIPTIONS
  getSubscriptions: `${API_MYEDUZZ}/subscriptions/{id}`,
  listSubscriptions: `${API_MYEDUZZ}/subscriptions`,
  listSubscriptionsNext: `${API_MYEDUZZ}/subscriptions/next`,
  listSubscriptionsInvoices: `${API_MYEDUZZ}/subscriptions/{id}/invoices`,
  listPostbackInvoices: `${API_MYEDUZZ}/subscriptions/{id}/invoices/{invoice_id}/postbacks`,
  newChargeInvoice: `${API_MYEDUZZ}/subscriptions/{id}/invoices/{invoice_id}/newcharge`,
  cancelSubscription: `${API_MYEDUZZ}/subscriptions/{id}/cancel`,
  reactivateSubscription: `${API_MYEDUZZ}/subscriptions/{id}/reactivate`,
  suspendSubscription: `${API_MYEDUZZ}/subscriptions/{id}/suspend`,
  getNextToken: `${API_MYEDUZZ}/subscriptions/next/token`,
  listSubscriptionProducts: `${API_MYEDUZZ}/subscriptions/products`,
  listSubscriptionStatus: `${API_MYEDUZZ}/subscriptions/status`,
  addAffiliate: `${API_MYEDUZZ}/subscriptions/{id}/addAffiliate`,
  changeChargeEmail: `${API_MYEDUZZ}/subscriptions/{id}/charge_email`,
  changePayment: `${API_MYEDUZZ}/subscriptions/{id}/change_payment`,
  bankslip: `${API_MYEDUZZ}/bankslip/view/{hash}`,
  changePaymentBankslip: `${API_MYEDUZZ}/subscriptions/{id}/bankslip`,
  saveNegotiateInvoices: `${API_MYEDUZZ}/subscriptions/{id}/invoices/negociate`,
  // ORDERS
  listOrders: `${API_MYEDUZZ}/orders`,
  listOrdersItems: `${API_MYEDUZZ}/orders/{invoice_id}/items`,
  changeItemTrack: `${API_MYEDUZZ}/orders/{invoice_id}/items/{item_id}`,
  changeTrack: `${API_MYEDUZZ}/orders/{invoice_id}/`,
  markAsSent: `${API_MYEDUZZ}/orders/{invoice_id}/send`,
  filterProducts: `${API_MYEDUZZ}/orders/filters/products`,
  filterStatus: `${API_MYEDUZZ}/orders/filters/status`,
  generateLabel: `${API_MYEDUZZ}/orders/tags`,
  // SHOWCASE
  listShowcase: `${API_MYEDUZZ}/showcase`,
  listShowcaseBestsellers: `${API_MYEDUZZ}/showcase/bestsellers?limit={limit}`,
  listShowcaseFresh: `${API_MYEDUZZ}/showcase/fresh?limit={limit}`,
  listShowcaseProducer: `${API_MYEDUZZ}/showcase/producer?limit={limit}`,
  listShowcaseAffiliate: `${API_MYEDUZZ}/showcase/affiliate?limit={limit}`,
  listShowcasePhysical: `${API_MYEDUZZ}/showcase/bestsellers?type={type}&limit={limit}`,
  getSubscriptionsShowcase: `${API_MYEDUZZ}/showcase/subscriptions?limit={limit}`,
  showProduct: `${API_MYEDUZZ}/showcase/{id}/details`,
  listAdvertisementMaterial: `${API_MYEDUZZ}/showcase/{id}/advertisement`,
  listShowcaseQuestions: `${API_MYEDUZZ}/showcase/{id}/questions?per_page={per_page}`,
  askQuestion: `${API_MYEDUZZ}/showcase/{id}/questions`,
  allRatingsShowcase: `${API_MYEDUZZ}/showcase/{id}/rating-all`,
  ratingShowcase: `${API_MYEDUZZ}/showcase/{id}/rating?per_page={per_page}`,
  createAffiliate: `${API_MYEDUZZ}/showcase/{id}/affiliate`,
  showcaseProfile: `${API_MYEDUZZ}/showcase/profile/{id}`,
  rateProducer: `${API_MYEDUZZ}/showcase/profile/{id}/rate`,
  //QUESTIONS
  listQuestions: `${API_MYEDUZZ}/questions`,
  listChatQuestions: `${API_MYEDUZZ}/questions/{chat_id}/chat`,
  answerQuestion: `${API_MYEDUZZ}/questions/{chat_id}/producer_answer`,
  updateQuestion: `${API_MYEDUZZ}/questions/{chat_id}/chat/{id}`,
  // RATING
  listRatingProduct: `${API_MYEDUZZ}/rating/product`,
  updateRatingProduct: `${API_MYEDUZZ}/rating/{id}/product`,
  listRatingProducer: `${API_MYEDUZZ}/rating/producer`,
  updateRatingProducer: `${API_MYEDUZZ}/rating/producer`,
  // EXTERNALS
  getAddressByZipCode: 'https://viacep.com.br/ws/{zip_code}/json',
  // CONFIG API / WEBHOOK
  apiKey: `${API_MYEDUZZ}/config/apikey`,
  testeWebhook: `${API_MYEDUZZ}/config/test/webhook`,
  // APPS
  getAccessApp: `${API_MYEDUZZ}/applications/{name_app}`,
  // WHITELIST
  listWhitelist: `${API_MYEDUZZ}/whitelist`,
  updateWhitelist: `${API_MYEDUZZ}/whitelist/{id}`,
  // SUPPORT
  tickets: `${API_MYEDUZZ}/support/tickets`,
  listChargebacks: `${API_MYEDUZZ}/reports/chargebacks`,
  listFilesChargeback: `${API_MYEDUZZ}/reports/chargebacks/{invoice_id}/files`,
  removeFileChargeback: `${API_MYEDUZZ}/reports/chargebacks/{invoice_id}/files/{file_id}`,
  // Messaging Internal
  messages: `${API_MYEDUZZ}/chat`,
  //CONNECT
  listMyConnects: `${API_MYEDUZZ}/connect`,
  listActionsMyConnect: `${API_MYEDUZZ}/connect/{connect_id}/actions`,
  listConnects: `${API_MYEDUZZ}/connect/autoresponders`,
  listTriggers: `${API_MYEDUZZ}/connect/triggers`,
  insertNewConnect: `${API_MYEDUZZ}/connect`,
  updateConnect: `${API_MYEDUZZ}/connect`,
  insertNewAction: `${API_MYEDUZZ}/connect/{connect_id}/actions`,
  listConnectProducts: `${API_MYEDUZZ}/connect/autoresponders/products`,
  listConnectOptions: `${API_MYEDUZZ}/connect/autoresponders/{autoresponder_id}/options`,
  loadConnect: `${API_MYEDUZZ}/connect/{connect_id}`,
  loadAction: `${API_MYEDUZZ}/connect/{connect_id}/actions/{action_id}`,
  updateAction: `${API_MYEDUZZ}/connect/{connect_id}/actions/{action_id}`,
  changeStatusConnect: `${API_MYEDUZZ}/connect/{connect_id}/active`,
  connectActionFields: `${API_MYEDUZZ}/connect/lists/{provider_id}/{autoresponder_id}`,
  validateMailChimp: `${API_MYEDUZZ}/connect/validate/mailchimp`,
  validateAweber: `${API_MYEDUZZ}/connect/validate/aweber`,
  validateInfusionsoft: `${API_MYEDUZZ}/connect/validate/infusionsoft`,
  validateRDStation: `${API_MYEDUZZ}/connect/validate/rd_station`,
  // PAYMENT METHODS
  paymentMethods: `${API_MYEDUZZ}/payment-methods`,
  // SHOPPING
  shopping: `${API_MYEDUZZ}/shopping`,
  // WEBHOOK
  listWebhookUrls: `${API_MYEDUZZ}/webhook/urls`,
  chagenWebhookUrlStatus: `${API_MYEDUZZ}/webhook/urls/{id}/status`,
  deleteWebhookUrl: `${API_MYEDUZZ}/webhook/urls/{id}`,
  listWebhookHistory: `${API_MYEDUZZ}/webhook/`,
  listSends: `${API_MYEDUZZ}/webhook/{id}/send`,
  listWebhookProducts: `${API_MYEDUZZ}/webhook/products`,
  createWebhookUrl: `${API_MYEDUZZ}/webhook/urls`,
  updateWebhookUrl: `${API_MYEDUZZ}/webhook/urls/{id}`,
  sendWebhookTest: `${API_MYEDUZZ}/webhook/test`,
  resendWebhook: `${API_MYEDUZZ}/webhook/{id}/send`,
  listAllNewzz: `${API_MYEDUZZ}/news`,
  loadNewzz: `${API_MYEDUZZ}/news`,
  listProductsCampaignFilter: `${API_MYEDUZZ}/products/campaigns-filter`,
  //EDITPRODUCT
  loadEditProduct: `${API_MYEDUZZ}/newproduct`,
  enableMelhorEnvioIntegration: `${API_MYEDUZZ}/shopiary/integrate/melhor-envio`,
  getDeliveryIntegrationActiveList: `${API_MYEDUZZ}/shopiary/delivery-integration-status`,
  //VERSION
  version: `${API_MYEDUZZ}/version`,
};
